import { HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { combineLatest as observableCombineLatest, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AjaxData, AjaxService, formUrlEncodedHttpOptions } from '../core/ajax.service';
import { AppConfigService } from '../core/app-config.service';
import { CustomEncoder } from '../common/customer-encoder';
import { Customer } from '../customers/customer-common';
import { CustomerVoiceRouterService } from '../core/cv-router.service';
import { ApiRoutesV1 } from '../common/routes';
import { NoPreferredSitesDialogComponent } from '../settings/preferred-sites/no-preferred-sites-dialog.component';
import { NoListingBuilderDialogComponent } from './no-listing-builder-dialog.component';

@Injectable()
export class SendEmailService {
  partnerId$: Observable<string>;

  constructor(
    private ajaxService: AjaxService,
    private appConfigService: AppConfigService,
    private customerVoiceRouter: CustomerVoiceRouterService,
    public dialog: MatDialog,
  ) {
    this.partnerId$ = this.appConfigService.appConfig.pipe(map((config) => config.partnerId));
  }

  public sendReviewRequestEmail(recipients: Customer[], templateId: string): Observable<HttpResponse<AjaxData>> {
    const addPayload: HttpParams = new HttpParams({
      encoder: new CustomEncoder(),
    }).set('contactsJson', JSON.stringify(recipients));

    return observableCombineLatest([this.partnerId$, this.customerVoiceRouter.accountGroupId]).pipe(
      switchMap(([partnerId, accountGroupId]) => {
        return this.ajaxService.post(ApiRoutesV1.sendEmailRequests, addPayload, {
          ...formUrlEncodedHttpOptions,
          params: {
            partnerId: partnerId,
            accountGroupId: accountGroupId,
            templateId: templateId,
          },
        });
      }),
    );
  }

  public openNoPreferredSitesDialog(): void {
    this.dialog.open(NoPreferredSitesDialogComponent, {
      data: {
        messageType: 'email',
      },
    });
  }

  public openNoListingBuilderDialog(): void {
    this.dialog.open(NoListingBuilderDialogComponent);
  }
}
